import * as yup from 'yup'

const schema = yup.object().shape({
  name: yup.string().required('Nome é obrigatório'),
  email: yup.string().email('E-mail inválido').nullable(),
  phone: yup.string().nullable(),
})

export default schema
